<template>
  <div class="contentHome ">
    <div class="centerPage">
      <meta name="referrer" content="no-referrer">
      <div class="search-box">
        <router-link class="title " to="/news">新闻资讯</router-link>
        <span class="title active">每日研究</span>
        <router-link class="title" to="/publicWelfare">亦笙公益</router-link>
        <router-link class="title" to="/regionalResources">地区资源</router-link>
        <el-input size="mini" v-model="page.keyword" class="search" suffix-icon="el-icon-search" placeholder="搜索"
                  @change="skipPage(1)"></el-input>
      </div>
      <div class="flex" style="align-items: normal">
        <div class="left">
          <span class="title">文章类型</span>
          <div class="type">
            <p @click="change(0,0)" :class="active==0?'activeClass':''">
              <span>全部</span>
              <img src="../../assets/img/activeImg.png" alt="" width="17" v-show="active==0">
            </p>
            <p v-for="(obj,index) in articleTypes" :key="obj.id" :class="active==index+1?'activeClass':''"
               @click="change(index+1,obj.id)">
              <span>{{ obj.itemName }}</span>
              <img src="../../assets/img/activeImg.png" alt="" width="17" v-show="active==index+1">
            </p>
          </div>
        </div>
        <div class="right">
          <div v-if="page.total==0" style="text-align: center;color: #DFE0E7">
            <img src="../../assets/img/empty_tips.png" alt="">
            <div>暂无数据</div>
          </div>

          <div class="studyList" v-for="(v,k) in page.data" :key="k">
            <span class="time">{{ k }}</span>
            <div class="listS " v-for="(obj,index) in v" :key="obj.id">
              <template v-if="index%2==0">
                <div class="flex flexLi" @click="toDetail(obj)" style="cursor: pointer">
                  <div class="con">
                    <h3>{{ obj.title }}</h3>
                    <p class="description">{{ obj.summary }}</p>
                    <p class="count">
                      <span>{{ obj.doctorName }}</span>
                      <span>{{ obj.viewsCount }}阅读</span>
                      <span class="belongTo">{{ obj | getTypeName(that) }}</span>
                      <a href="javascript:;" class="flex">READ MORE<img src="../../assets/img/study_more.png" alt=""
                                                                        width="20"></a>
                    </p>
                  </div>
                  <div class="objImg img" :style="'backgroundImage: url('+obj.thumbnailPath+')'"></div>
                </div>
              </template>

              <template v-if="index%2!=0">
                <div class="flex flexLi" @click="toDetail(obj)" style="cursor: pointer">
                  <div class="objImg img" :style="'backgroundImage: url('+obj.thumbnailPath+')'"></div>
                  <div class="con">
                    <h3>{{ obj.title }}</h3>
                    <p class="description">{{ obj.summary }}</p>
                    <p class="count">
                      <span>{{ obj.doctorName }}</span>
                      <span>{{ obj.viewsCount }}阅读</span>
                      <span class="belongTo">{{ obj | getTypeName(that) }}</span>
                      <a href="javascript:;" class="flex">READ MORE<img
                          src="../../assets/img/study_more.png"
                          alt="" width="20"></a>
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <el-pagination
              background
              prev-text="Prev"
              next-text="Next"
              class="pagination"
              :hide-on-single-page="true"
              @current-change="skipPage"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next, total"
              :total="page.total">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import base from '@/api/common';

export default {
  name: "study",
  data() {
    return {
      that: this,
      articleType: [],
      active: 0,
      study: [],

      articleTypes: [],
      articleTypeMap: new Map(),

      page: {
        current: 1,
        size: 5,
        total: 12,
        keyword: '',
        type: 0,
        index: 0,
        data: {},
      },

    }
  },
  mounted() {
    /*
    try{
        this.$parent.$refs.headerRef.active = 2;
    }catch (e) {
        console.error(e);
    }*/
    // load types
    this.$ajax.get(base.api.dict.article.research).then((res) => {
      if (res.data.status === 'success') {
        this.articleTypes = res.data.list;
        $(res.data.list).each((i, o) => {
          this.articleTypeMap.set(o.id, o);
        });
        this.getData();
      }
    })
  },
  methods: {
    getData() {
      let that = this;
      this.$ajax.get(base.api.article.research.page.replace("{type}", this.page.type) + '?keyword=' + that.page.keyword, {
        params: {
          page: this.page.current,
          size: this.page.size,
        }
      }).then((res) => {
        if (res.data.status === 'success') {
          let dateMap = new Map();
          $(res.data.rows).each((i, o) => {
            // 显示默认缩略图
            if (!o.thumbnailPath) {
              o.thumbnailPath = that.articleTypeMap.get(o.pageType).itemIcon;
            }
            let mapEle = dateMap.get(o.publishDate);
            if (mapEle) {
              mapEle.list.push(o);
            } else {
              dateMap.set(o.publishDate, {list: [o]})
            }
          });
          let data = new Object();
          dateMap.forEach((v, k) => {
            data[k] = v.list;
          });
          this.page.data = data;
          this.page.current = res.data.current;
          this.page.total = res.data.total;
          this.page.size = res.data.size;
        }
      })
      //document.querySelector('.homeIndex').scrollTop = 0;//回到顶部
    },
    change(index, typeId) {
      this.active = index;
      this.page.current = 1; // 页码重置
      this.page.type = typeId;
      this.$nextTick(this.getData());
    },
    skipPage(cur) {
      this.page.current = cur;
      this.getData();
      this.$nextTick(() => {
        $(".contentIndex").animate({scrollTop: '0px'}, 800);
      });
    },
    toDetail(item) {
      this.$router.push({name: 'studyDetail', query: {id: item.id, d: item.doctorName, t: item.typeName}});
    }
  },
  filters: {
    getTypeName(item, that) {
      if (item && item.pageType) {
        let type = that.articleTypeMap.get(item.pageType);
        if (type) {
          item.typeName = type.itemName;
          return item.typeName;
        }
      }
      return '未分类';
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/serviceType.scss";

.centerPage {
  //display: flex;
}
</style>
